"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fonts = {
  family: {
    text: 'proxima-nova, "Helvetica Neue", Helvetica, Arial, sans-serif',
    semiBold: 'Proxima-Nova-Semibold',
    medium: 'Proxima-Nova-Medium',
    regular: 'Proxima-Nova-Regular',
    code: 'Roboto Mono, monospace'
  },
  weight: {
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  },
  size: {
    xsmall: '12px',
    small: '13px'
  },
  letterSpacing: {
    "default": '0.3px',
    normal: 'normal'
  }
};
var _default = fonts;
exports["default"] = _default;